import { QueryClient, type QueryKey } from "@tanstack/react-query";

const DEFAULT_STALE_TIME = 60_000;

export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 10 * 60 * 1000,
      retry: false,
    },
  },
});

export async function fetchWithCache<T>(params: {
  queryKey: QueryKey;
  queryFn: () => Promise<T>;
  fallback: T;
  staleTime?: number;
}): Promise<T> {
  try {
    return await appQueryClient.fetchQuery({
      queryKey: params.queryKey,
      queryFn: params.queryFn,
      staleTime: params.staleTime ?? DEFAULT_STALE_TIME,
    });
  } catch {
    return params.fallback;
  }
}

export async function invalidateAppQueries(queryKey: QueryKey) {
  await appQueryClient.invalidateQueries({ queryKey });
}

export function setAppQueryData<T>(
  queryKey: QueryKey,
  updater: (old: T | undefined) => T | undefined
) {
  appQueryClient.setQueryData<T>(queryKey, updater);
}
